module.exports = __webpack_public_path__ + "img/infographic-empty.fb854586.jpg";